'use client'
import React from 'react';
import SvgButton from "@/components/SvgButton";
import styled from "styled-components";

const SweeperNav = ({
                        prevId,nextID,
                        prevSvg,
                        nextSvg,
                        borderColor = '#ffffff'}) => {


    return (
        <StyledNavigation>
            <ul className="navigation">
                {/* Previous Button */}
                <li
                    id={`${prevId ? prevId :''}`}
                    className={`${prevId ? prevId :'prev'}`}

                >
                    <SvgButton svg={prevSvg} borderColor={borderColor} />
                </li>

                {/* Next Button */}
                <li
                    id={` ${nextID ? nextID :''}`}
                    className={` ${nextID ? nextID :''} next`}

                >
                    <SvgButton svg={nextSvg} borderColor={borderColor} />
                </li>
            </ul>
        </StyledNavigation>
    );
};
const StyledNavigation = styled.section`
    ul {
        display: flex;

        li {
            margin-left: 10px;
            cursor: pointer;
            //background: red;
        }
    }

    .next {
        #Group_19850 {
            transition: .2s ease-in-out;
        }

        #Group_19851 {
            transition: .2s ease-in-out;
        }

        transition: .2s ease-in-out;

        &:hover {
            svg {
                #Group_19850 {
                    transform: translate(8px, 9px);
                    transition: .2s ease-in-out;
                }

                #Group_19851 {
                    transform: translate(55px, 9px);
                    transition: .2s ease-in-out;
                }

            }
        }


    }

    .prev {
        #Group_19850 {
            transition: .2s ease-in-out;
        }

        #Group_19851 {
            transition: .2s ease-in-out;
        }

        transition: .2s ease-in-out;

        &:hover {
            svg {
                #Group_19850 {
                    transform: translate(-800px, -716.5px);
                    transition: .2s ease-in-out;
                }

                #Group_19851 {
                    transform: translate(-620px, -716.5px);
                    transition: .2s ease-in-out;
                }

            }
        }


    }

`
export default SweeperNav;
